import { cn } from '@/utils/styles';

export interface CircularProgressProps
  extends React.HTMLAttributes<HTMLDivElement> {
  indeterminate?: boolean;
}

export function CircularProgress({
  className,
  indeterminate = true,
  ...rest
}: CircularProgressProps) {
  return (
    <div
      {...rest}
      aria-valuemax={1}
      aria-valuemin={0}
      role="progressbar"
      aria-label="loading"
      data-indeterminate={indeterminate}
      className={cn(
        'data-[indeterminate=true]:animate-spin text-primary inline-block w-6 h-6',
        className,
      )}
    >
      <svg viewBox="0 0 32 32" height="100%" width="100%" color="inherit">
        <circle
          r="14"
          cx="16"
          cy="16"
          fill="none"
          color="inherit"
          strokeWidth="4"
          style={{
            stroke: 'currentColor',
            opacity: 0.2,
          }}
        />

        <circle
          r="14"
          cx="16"
          cy="16"
          fill="none"
          color="inherit"
          strokeWidth="4"
          style={{
            stroke: 'currentColor',
            strokeDasharray: 80,
            strokeDashoffset: 60,
          }}
        />
      </svg>
    </div>
  );
}
